<template>
  <div class="order-content-wrap">
    <div class="head-btn-wrap">
      <div class="btn">
        <package-dialog @on-change="addPackage">添加课包 +</package-dialog>
      </div>
      <div class="btn" v-if="orderCourseSwitch">
        <course-dialog @on-change="checkCourse">添加课程 +</course-dialog>
      </div>
      <div class="btn">
        <set-dialog @on-change="inputSet">
          <div class="mwow-button-filled primary">添加套餐 +</div>
        </set-dialog>
      </div>
    </div>
    <div class="table-wrap mwow-table">
      <div class="th">
        <div class="td">购买内容</div>
        <div class="td">业务形式</div>
        <div class="td">内容价格</div>
        <div class="td">购买数量</div>
        <div class="td">总价</div>
        <div class="td">赠送数量</div>
        <div class="td">直减</div>
        <div class="td">小计</div>
        <div class="td">操作</div>
      </div>
      <div class="no-data" v-if="tableData.length === 0">请选择购买内容</div>
      <div class="item" v-for="(item, index) in tableData" :key="index">
        <!-- 课程 -->
        <div v-if="item.type === 'course'">
          <div class="title">
            <p class="text">【课程】- {{ item.course_name }}</p>
            <div class="delete-btn-wrap">
              <div class="mwow-button danger" @click="handleDelete(index)">
                删除
              </div>
            </div>
          </div>
          <div class="tr">
            <div class="td course-name">{{ item.course_name }}</div>
            <div class="td">
              <p v-if="item.business_type === 0">-</p>
              <p v-if="item.business_type === 1">新购</p>
              <p v-if="item.business_type === 2">续费</p>
              <p v-if="item.business_type === 3">拓科</p>
            </div>
            <div class="td">
              <el-select
                v-model="item.course_spec_id"
                @change="
                  (v) => {
                    item.quantity = Number(courseSpecObj[v].quantity);
                    item.unit_price = Number(courseSpecObj[v].unit_price);
                    item.price = Number(courseSpecObj[v].price);
                    item.sum =
                      (solveLargeNumber(courseSpecObj[v].price) -
                        solveLargeNumber(item.discount)) /
                      100;
                    solveTableTotal();
                  }
                "
                :disabled="item.disabled"
              >
                <el-option
                  v-for="it in item.course_spec"
                  :key="it.course_spec_id"
                  :label="it.name"
                  :value="it.course_spec_id"
                ></el-option>
              </el-select>
            </div>
            <div class="td inner-p">
              <el-input
                v-model="item.quantity"
                :disabled="
                  item.disabled
                    ? true
                    : courseSpecObj[item.course_spec_id]
                    ? Number(courseSpecObj[item.course_spec_id].quantity) !== 1
                    : true
                "
                type="number"
                @input="
                  () => {
                    item.effective_time = solveDefaultEffectTime(item); // 根据购买数量设定有效期
                  }
                "
                @change="
                  (v) => {
                    let n =
                      Number(item.quantity) >= 1
                        ? Number(Number(item.quantity).toFixed(2))
                        : 0;
                    item.quantity = n;
                    item.price =
                      (solveLargeNumber(n) *
                        solveLargeNumber(item.unit_price)) /
                      10000;
                    item.sum = solveSum(
                      item.unit_price,
                      item.quantity,
                      item.discount
                    );
                    solveTableTotal();
                  }
                "
              ></el-input
              ><span class="append">课时</span>
            </div>
            <div class="td">￥{{ item.price }}</div>
            <div class="td inner-p">
              <el-input
                v-model="item.give_quantity"
                type="number"
                @change="handleGiveQuantity(item)"
                :disabled="item.disabled"
              ></el-input>
              <span class="append">课时</span>
            </div>
            <div class="td">
              <div class="tabInp">
                <el-select
                  v-model="item.discount_type"
                  class="discount-select"
                  :disabled="item.disabled"
                >
                  <el-option label="直减" :value="0"></el-option>
                  <!-- <el-option label="折扣" :value="1"></el-option> -->
                </el-select>
                <el-input
                  class="discount-input"
                  v-model="item.discount"
                  v-if="item.discount_type === 0"
                  type="number"
                  @input="handleDiscountInput(item)"
                  @change="handleDiscountChange(item)"
                  :disabled="item.disabled"
                  ><template slot="prepend">￥</template></el-input
                >
                <el-input
                  v-model="item.discount"
                  v-if="item.discount_type === 1"
                  type="number"
                  :disabled="item.disabled"
                  ><template slot="prepend">%</template></el-input
                >
              </div>
            </div>
            <div class="td">
              <el-input v-model="item.sum" disabled
                ><template slot="prepend"> ￥ </template></el-input
              >
            </div>
            <div class="td"></div>
          </div>
          <div class="date-wrap">
            <span class="label">课程有效期：</span>
            <el-date-picker
              v-model="item.effective_time"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              :picker-options="effectiveTimeOption"
              :disabled="item.disabled"
            >
            </el-date-picker>
            <el-tooltip
              effect="dark"
              content="有效期根据购买数量匹配显示可更改，超过有效期的课程，会显示过期标签"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </div>
        <!-- 套餐 -->
        <div v-if="item.type === 'set'">
          <div class="title">
            <p class="text">【套餐】- {{ item.name }}</p>
            <div class="delete-btn-wrap">
              <div class="mwow-button danger" @click="handleDelete(index)">
                删除
              </div>
            </div>
          </div>
          <div v-for="(it, idx) in item.item" :key="idx">
            <div class="tr">
              <div class="td">{{ it.product_name }}</div>
              <div class="td">
                <p v-if="it.business_type === 0">-</p>
                <p v-if="it.business_type === 1">新购</p>
                <p v-if="it.business_type === 2">续费</p>
                <p v-if="it.business_type === 3">拓科</p>
              </div>
              <div class="td">￥{{ it.unit_price }}</div>
              <div class="td">{{ it.quantity }}课时</div>
              <div class="td">￥{{ it.subtotal }}</div>
              <div class="td inner-p">
                <el-input
                  style="width: 80px"
                  v-model="it.give_quantity"
                  type="number"
                  @change="handleGiveQuantitySet(it)"
                  :disabled="item.disabled"
                ></el-input
                ><span class="append">课时</span>
              </div>
              <div class="td">
                <div class="tabInp">
                  <el-select
                    v-model="it.discount_type"
                    class="discount-select"
                    :disabled="item.disabled"
                  >
                    <el-option label="直减" :value="0"></el-option>
                    <!-- <el-option label="折扣" :value="1"></el-option> -->
                  </el-select>
                  <el-input
                    class="discount-input"
                    v-model="it.discount"
                    type="number"
                    v-if="it.discount_type === 0"
                    @input="handleDiscountInput(it)"
                    @change="handleDiscountSetChange(it)"
                    :disabled="item.disabled"
                    ><template slot="prepend">￥</template></el-input
                  >
                  <el-input
                    v-model="it.discount"
                    type="number"
                    v-if="it.discount_type === 1"
                    :disabled="item.disabled"
                    ><template slot="prepend">%</template></el-input
                  >
                </div>
              </div>
              <div class="td">
                <el-input v-model="it.sum" disabled type="number"
                  ><template slot="prepend">￥</template></el-input
                >
              </div>
              <div class="td"></div>
            </div>
            <div class="date-wrap">
              <span class="label">课程有效期：</span>
              <el-date-picker
                v-model="it.effective_time"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                :picker-options="effectiveTimeOption"
                :disabled="item.disabled"
              >
              </el-date-picker>
              <el-tooltip
                effect="dark"
                content="有效期根据购买数量匹配显示可更改，超过有效期的课程，会显示过期标签"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setDetail, studentCourseDetailApi } from "@/api/course";
import { dateFormat } from "@/utils/timeFormat";
import { UserModule } from "@/store/module/user";
import courseDialog from "@/view/teachManagement/buyCourseConfirm/courseDialog.vue";
import setDialog from "@/view/teachManagement/buyCourseConfirm/setDialog.vue";
import packageDialog from "@/view/teachManagement/buyCourseConfirm/packageDialog.vue";
export default {
  components: {
    courseDialog,
    setDialog,
    packageDialog,
  },
  props: ["student-id", "origin-order-data"],
  data() {
    return {
      // 课程和套餐
      tableSumPrice: 0,
      nowPayPrice: "", // 拆分支付
      courseSpecObj: {},
      tableData: [],
      courseIds: [],
      showStar: false, // 显示备注必填标识
      effectiveTimeOption: {
        disabledDate: (date) => {
          return date.getTime() < Date.now();
        },
      },
      deleteIds: [], // 旧订单数据删除后需要提交给后端
    };
  },
  computed: {
    orderCourseSwitch() {
      return UserModule.userInfo.order_course_switch === 1;
    },
  },
  watch: {
    originOrderData(n) {
      // 旧数据直接沿用，且不可编辑，只能删除
      n.map((item) => {
        if (!item.is_combo) {
          this.courseSpecObj[item.list[0].spec_id] = {
            course_spec_id: item.list[0].spec_id,
            name: item.list[0].spec_name,
          };
          this.tableData.push({
            type: "course",
            course_name: item.list[0].product_name,
            business_type: item.list[0].business_type,
            quantity: item.list[0].quantity,
            unit_price: item.list[0].spec_unit_price,
            price: item.list[0].amount,
            sum: item.list[0].receivable_amount,
            discount: item.list[0].discount_amount,
            course_spec: [
              {
                course_spec_id: item.list[0].spec_id,
                name: item.list[0].spec_name,
              },
            ],
            course_spec_id: item.list[0].spec_id,
            effective_time: item.list[0].course_end_time
              ? dateFormat("YYYY-mm-dd", item.list[0].course_end_time * 1000)
              : "",
            give_quantity: item.list[0].give_product_quantity,
            discount_type: 0,
            course_id: item.list[0].product_id,
            disabled: true,
            item_id: item.list[0].item_id,
            course_type: item.item_type,
          });
        } else {
          this.tableData.push({
            type: "set",
            name: item.item_name,
            combo_product_id: item.list[0].combo_product_id,
            item: item.list.map((c) => {
              return {
                option_id: c.item_id,
                product_name: c.product_name,
                business_type: c.business_type,
                unit_price: c.spec_unit_price,
                quantity: c.quantity,
                subtotal: c.amount,
                give_quantity: c.give_product_quantity,
                discount_type: 0,
                discount: c.discount_amount,
                sum: c.receivable_amount,
                effective_time: c.course_end_time
                  ? dateFormat("YYYY-mm-dd", c.course_end_time * 1000)
                  : "",
                item_id: c.item_id,
                product_id: c.product_id,
              };
            }),
            disabled: true,
          });
        }
      });
      this.solveTableTotal();
    },
  },
  methods: {
    solveSum(unit_price, quantity, dec) {
      return (
        Math.ceil(
          (this.solveLargeNumber(unit_price) * this.solveLargeNumber(quantity) -
            this.solveLargeNumber(dec) * 100) /
            100
        ) / 100
      );
    },
    solveLargeNumber(v) {
      const n = String(Number(v));
      let res = 0;
      const l = String(n).split(".");
      if (l.length <= 1) {
        res = Number(n) * 100;
      } else if (l[1].length === 1) {
        res = Number(String(n).replace(/\./, "") + "0");
      } else if (l[1].length === 2) {
        res = Number(String(n).replace(/\./, ""));
      } else if (l[1].length > 2) {
        res = Math.ceil(Number(n) * 100);
      } else {
        res = Number(n) * 100;
      }
      return res;
    },
    addPackage(row) {
      this.checkCourse([
        {
          course_id: row.course.course_id,
          course_spec_id: row.spec_id,
          title: row.course.title,
        },
      ]);
    },
    checkCourse(arr) {
      const cur = [];
      this.tableData.map((item) => {
        if (item.type === "course") {
          cur.push(item.course_id);
        }
        if (item.type === "set") {
          item.item.map((it) => {
            cur.push(it.product_id);
          });
        }
      });
      const duplicate = [];
      arr.map((item) => {
        if (cur.includes(item.course_id)) {
          duplicate.push(item.title);
        }
      });
      if (duplicate.length > 0) {
        this.$message({
          type: "warning",
          message:
            "此套餐中包含已选的课程“" +
            duplicate.join("、") +
            "”，不能重复选择。",
        });
        return false;
      }
      const courseIds = [];
      const specIds = [];
      arr.map((item) => {
        if (item.course_id) {
          courseIds.push(item.course_id);
          specIds.push(item.course_spec_id || 0);
        }
      });
      this.inputCourse(courseIds, specIds);
    },
    inputCourse(cids, specIds) {
      studentCourseDetailApi({
        course_ids: cids,
        student_id: this.studentId,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.list.length > 0) {
            res.data.list.map((it, idx) => {
              it.course_spec.map((s) => {
                this.courseSpecObj[s.course_spec_id] = s;
              });
              let course = {
                type: "course",
                discount_type: 0,
                discount: 0,
                give_quantity: 0,
                effective_time: "",
                course_spec: it.course_spec,
                course_name: it.course.title,
                course_id: it.course.course_id,
                business_type: it.business_type,
                course_type: it.course.course_type,
              };
              // 规格默认值
              if (specIds) {
                course.course_spec_id =
                  specIds[idx] || it.course_spec[0].course_spec_id;
                let target = it.course_spec.find((sp) => {
                  return sp.course_spec_id === course.course_spec_id;
                });
                course.quantity = Number(target.quantity);
                course.unit_price = Number(target.unit_price);
                course.sum = Number(target.price);
                course.price = Number(target.price);
              } else {
                course.course_spec_id = it.course_spec[0].course_spec_id;
                course.quantity = Number(it.course_spec[0].quantity);
                course.unit_price = Number(it.course_spec[0].unit_price);
                course.sum = Number(it.course_spec[0].price);
                course.price = Number(it.course_spec[0].price);
              }
              course.effective_time = this.solveDefaultEffectTime(course);
              this.tableData.push(course);
              if (it.course.sales_status !== 1) {
                this.$message({
                  type: "error",
                  message: "该课程已下架",
                });
                return false;
              }
            });
            this.solveTableTotal();
            // 每次加入课程，重置现付金额为tableSumPrice
            // this.nowPayPrice = this.tableSumPrice;
            this.nowPayPrice = "";
          }
        }
      });
    },
    inputSet(arr) {
      const cur = [];
      const self = [];
      let duplicate = [];
      this.tableData.map((item) => {
        if (item.type === "course") {
          cur.push(item.course_id);
        }
        if (item.type === "set") {
          item.item.map((it) => {
            cur.push(it.product_id);
          });
        }
      });
      // 与外部对比
      arr.map((item) => {
        item.item.map((it) => {
          if (cur.includes(it.product_id)) {
            duplicate.push(it.product_name);
          }
          self.push(it.product_id);
        });
      });
      // 当前批次内对比
      arr.map((item) => {
        item.item.map((it) => {
          if (self.filter((v) => v === it.product_id).length > 1) {
            duplicate.push(it.product_name);
          }
        });
      });
      duplicate = [...new Set(duplicate)];
      if (duplicate.length > 0) {
        this.$message({
          type: "warning",
          message: `此套餐中包含已选的课程“${duplicate.join(
            "、"
          )}”，不能重复选择`,
        });
        return false;
      }
      const requests = arr.map((item) => {
        if (item.combo_product_id) {
          return setDetail({ combo_product_id: item.combo_product_id }).then(
            (res) => {
              if (res.error_code === 0) {
                const items = [];
                res.data.item.map((it) => {
                  items.push({
                    option_id: it.item_id,
                    product_id: it.product_id,
                    product_name: it.product_name,
                    quantity: Number(it.quantity),
                    discount_type: 0,
                    discount: 0,
                    give_quantity: 0,
                    effective_time: "",
                    sum: Number(it.subtotal),
                    subtotal: Number(it.subtotal),
                    unit_price: Number(it.unit_price),
                    business_type: 0,
                  });
                  this.courseIds.push(it.product_id);
                });
                this.tableData.push({
                  type: "set",
                  combo_product_id: item.combo_product_id,
                  name: item.name,
                  item: items,
                });
                this.solveTableTotal();
                // 每次加入课程，重置现付金额为tableSumPrice
                // this.nowPayPrice = this.tableSumPrice;
                this.nowPayPrice = "";
              }
            }
          );
        }
      });
      Promise.all(requests).then((res) => {
        this.getStudentCourseBusiness();
      });
    },
    getStudentCourseBusiness() {
      studentCourseDetailApi({
        student_id: this.studentId,
        course_ids: this.courseIds,
      }).then((res) => {
        if (res.error_code === 0) {
          const obj = {};
          const num = [];
          res.data.list.map((item, index) => {
            obj["key" + index] = item;
            num.push(index);
          });
          this.tableData.map((item, index) => {
            if (item.item) {
              item.item.map((it, ind) => {
                if (it.product_id) {
                  for (let i = 0; i < num.length; i++) {
                    if (it.product_id === obj["key" + i].course.course_id) {
                      it.business_type = obj["key" + i].business_type;
                    }
                  }
                }
              });
            }
          });
        }
      });
    },
    // 课程赠送课时
    handleGiveQuantity(item) {
      let n = item.give_quantity
        ? Number(Number(item.give_quantity).toFixed(2))
        : 0;
      item.give_quantity = n;
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    // 课程直减金额
    handleDiscountInput(item) {
      if (!item.discount) {
        item.discount = 0;
        return false;
      }
      if (/^0\d/.test(String(item.discount))) {
        item.discount = Number(item.discount);
        return false;
      }
      if (/-/.test(String(item.discount))) {
        item.discount = Math.abs(Number(item.discount));
        return false;
      }
      if (/\.\d{3}/.test(String(item.discount))) {
        item.discount = Number(item.discount).toFixed(2);
        return false;
      }
    },
    handleDiscountChange(item) {
      let sum = 0;
      if (Number(this.courseSpecObj[item.course_spec_id].quantity) === 1) {
        sum = this.solveSum(item.unit_price, item.quantity, item.discount);
      } else {
        sum =
          (this.solveLargeNumber(item.price) -
            this.solveLargeNumber(item.discount)) /
          100;
      }
      if (sum < 0) {
        this.$message({
          type: "warning",
          message: "小计不可小于0",
        });
        item.discount = 0;
        if (Number(this.courseSpecObj[item.course_spec_id].quantity) === 1) {
          sum = this.solveSum(item.unit_price, item.quantity, 0);
        } else {
          sum = item.price;
        }
        item.sum = sum;
        this.solveTableTotal();
        return false;
      }
      item.sum = sum;
      this.solveTableTotal();
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    // 套餐总送课时
    handleGiveQuantitySet(item) {
      let n = item.give_quantity
        ? Number(Number(item.give_quantity).toFixed(2))
        : 0;
      item.give_quantity = n;
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    // 套餐直减金额
    handleDiscountSetChange(item) {
      let sum =
        (this.solveLargeNumber(item.subtotal) -
          this.solveLargeNumber(item.discount)) /
        100;
      if (sum < 0) {
        this.$message({
          type: "warning",
          message: "小计不可小于0",
        });
        item.discount = 0;
        item.sum = item.subtotal;
        this.solveTableTotal();
        return false;
      }
      item.sum = sum;
      this.solveTableTotal();
      if (item.give_quantity > 0 || item.discount > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    handleDelete(index) {
      let target = this.tableData[index];
      if (target.disabled) {
        // 旧数据
        let ids = [];
        if (target.type === "set") {
          ids = target.item.map((c) => {
            return c.item_id;
          });
        } else if (target.type === "course") {
          ids = [target.item_id];
        }
        this.deleteIds = [...new Set([...this.deleteIds, ...ids])];
      }
      this.tableData.splice(index, 1);
      this.solveTableTotal();
      this.courseIds = [];
    },
    solveTableTotal() {
      const table = [...this.tableData];
      let res = 0;
      table.map((row) => {
        if (row.type === "course") {
          if (Number(this.courseSpecObj[row.course_spec_id].quantity) === 1) {
            res =
              res +
              this.solveLargeNumber(row.unit_price) *
                this.solveLargeNumber(row.quantity) -
              this.solveLargeNumber(row.discount) * 100;
          } else {
            res =
              res +
              this.solveLargeNumber(row.price) * 100 -
              this.solveLargeNumber(row.discount) * 100;
          }
        }
        if (row.type === "set") {
          row.item.map((it) => {
            res =
              res +
              this.solveLargeNumber(it.subtotal) * 100 -
              this.solveLargeNumber(it.discount) * 100;
          });
        }
      });
      this.tableSumPrice = Math.ceil(res / 100) / 100;
      this.nowPayPrice = "";
    },
    solveDefaultEffectTime(course) {
      let buyQuantity = Number(course.quantity) || 0;
      let now = new Date();
      let endMonth = 0;
      if (course.course_type === 2) {
        // 1v1
        if (buyQuantity >= 0 && buyQuantity <= 30) {
          endMonth = 8;
        } else if (buyQuantity > 30 && buyQuantity <= 45) {
          endMonth = 12;
        } else if (buyQuantity > 45) {
          endMonth = 24;
        }
      } else if (course.course_type === 1) {
        // 1vN
        if (buyQuantity >= 0 && buyQuantity <= 45) {
          endMonth = 12;
        } else if (buyQuantity > 45 && buyQuantity <= 60) {
          endMonth = 15;
        } else if (buyQuantity > 60) {
          endMonth = 24;
        }
      }
      let resY = now.getFullYear() + Math.floor(endMonth / 12);
      let m = now.getMonth() + 1 + (endMonth % 12);
      if (m > 12) {
        resY = resY + 1;
      }
      let res = new Date(
        `${resY}/${m % 12 === 0 ? 12 : m % 12}/${now.getDate()} 00:00:00`
      );
      if (res.getDate() === now.getDate()) {
        // 不存在大小月误差
        return dateFormat("YYYY-mm-dd", res.getTime() - 24 * 60 * 60 * 1000);
      } else {
        return dateFormat(
          "YYYY-mm-dd",
          res.getTime() - res.getDate() * 24 * 60 * 60 * 1000
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.order-content-wrap {
  .head-btn-wrap {
    margin-bottom: 20px;
    .btn {
      display: inline-block;
      margin-right: 20px;
    }
  }
  /deep/.table-wrap {
    .no-data {
      font-size: 14px;
      text-align: center;
      color: #5c5d5e;
      padding: 12px;
    }
    .th {
      background-color: #f2f6fa;
      font-size: 12px;
      color: #5c5d5e;
      margin-bottom: 14px;
    }
    .tr {
      color: #5c5d5e;
      font-size: 12px;
    }
    .th,
    .tr {
      display: flex;
      align-items: center;
      padding: 0 34px;
      .el-select {
        .el-input {
          max-width: 160px;
        }
      }
      .el-input {
        max-width: 100px;
        .el-input-group__prepend {
          background: #ffffff;
          padding: 0 1px 0 9px !important;
          line-height: 20px;
          & + .el-input__inner {
            border-left: 0;
            padding-left: 1px !important;
          }
        }
      }
      .td {
        flex: 1;
        width: 0;
        overflow: hidden;
        font-size: 12px;
        line-height: 24px;
        min-height: 24px;
        color: #5c5d5e;
        padding: 9px 0;
      }
      .append {
        margin: 0 6px 0 4px;
        white-space: nowrap;
      }
      .td:nth-child(1) {
      }
      .td:nth-child(2) {
      }
      .td:nth-child(3) {
      }
      .td:nth-child(4) {
        display: flex;
        align-items: center;
        .el-input {
          flex: 1;
        }
      }
      .td:nth-child(5) {
      }
      .td:nth-child(6) {
        display: flex;
        align-items: center;
        .el-input {
          flex: 1;
        }
        .append {
          width: 24px;
        }
      }
      .td:nth-child(7) {
        flex: 2;
        .tabInp {
          background-color: #fff;
          .discount-select {
            width: 80px;
          }
          .discount-input {
            width: 100px;
            &.is-disabled {
              .el-input-group__prepend {
                background-color: #f5f7fa !important;
              }
            }
          }
        }
      }
      .td:nth-child(8) {
        .el-input-group__prepend {
          background: #f5f7fa;
          cursor: not-allowed;
        }
      }
      .td:nth-child(9) {
        flex: none;
        width: 48px;
        text-align: center;
      }
    }
    .item {
      border: 1px solid #e1e5e9;
      margin-bottom: 14px;
      .title {
        padding: 0 34px;
        background: #f2f6fa;
        display: flex;
        align-items: center;
        .text {
          line-height: 42px;
          font-size: 14px;
          color: #5c5d5e;
          font-weight: bold;
          flex: 1;
        }
        .delete-btn-wrap {
          width: 48px;
        }
      }
      .date-wrap {
        padding-left: 34px;
        line-height: 42px;
        background-color: #f6fafc;
        color: #5c5d5e;
        font-size: 12px;
        i {
          color: #bebfc0;
          font-size: 14px;
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
